import DepartmentList from "./DepartmentList";
export default DepartmentList;
